<template>
  <main>
    <div class="container-fluid">
      <div
        class="page-header min-height-300"
        style="
          background-image: url('https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80');
          margin-right: -24px;
          margin-left: -34%;
        "
      >
        <span class="mask bg-gradient-primary opacity-6"></span>
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto my-auto">
              <div class="avatar avatar-xl position-relative">
                <img
                  :src="'data:image/*;base64,'+partner.image"
                  alt="profile_image"
                  class="shadow-sm img-fluid"
                  v-if="partner.image"
                />
              </div>
            </div>
            <div class="col-auto">
              <div class="h-100">
                <p class="font-weight-bold mb-0">{{ partner.name }} - {{ partnerName }}</p>
                <p class="text-secondary text-sm mb-2">{{ partner.vendor_id }}</p>
                <div class="gap-2 d-grid d-flex">
                  <argon-button color="outline-secondary" size="xs" @click="edit = !edit" v-if="!edit">Edit Profile</argon-button>
                  <button class="btn btn-primary btn-xs" v-if="edit" @click="save">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                    Save Change
                  </button>
                  <button class="btn btn-outline-secondary btn-xs" v-if="edit" @click="discard">Discard</button>
                </div>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-5 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >
                <template v-for="item,i in tab" :key="i">
                  <li class="nav-item" v-if="item.active">
                    <a
                      class="px-0 py-1 mb-0 nav-link active"
                      data-bs-toggle="tab"
                      href="#"
                      role="tab"
                      @click="showTab(i)"
                      aria-selected="true"
                    >
                      <i :class="'fa ' + item.icon" aria-hidden="true"></i>
                      <span class="ms-1 text-sm">{{ item.name }}</span>
                    </a>
                  </li>
                </template>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">

          <div class="card mb-2" v-if="tab[0].visible && tab[0].active">
            <div class="card-body">
              <p class="text-uppercase text-sm">Company Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Username</label
                  >
                  <input v-model="partner.username" type="text" class="form-control" readonly>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Phone Number</label
                  >
                  <input v-model="partner.phone" type="text" class="form-control" :readonly="!edit">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Email address</label
                  >
                  <input v-model="partner.email" type="email" class="form-control" :readonly="!edit">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >NPWP</label
                  >
                  <input v-model="partner.vat" type="text" class="form-control" readonly>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Website</label
                  >
                  <input v-model="partner.website" type="text" class="form-control" :readonly="!edit">
                </div>
                <div class="col-md-auto pt-4">
                  <label for="example-text-input" class="form-control-label"
                    >Vendor Notification</label
                  >
                </div>
                <div class="col-md-2 pt-4">
                  <div class="form-check">
                    <input v-model="partner.vendor_notification" class="form-check-input" type="radio" name="radioVendorNotif" id="vendorNotifEmail" value="email">
                    <label class="form-check-label" for="vendorNotifEmail">
                        Handle By Emails
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="partner.vendor_notification" class="form-check-input" type="radio" name="radioVendorNotif" id="vendorNotifPortal" value="portal">
                    <label class="form-check-label" for="vendorNotifPortal">
                        Handle in Vendor Portal
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="tab[1].visible&& tab[1].active">
            <div class="card-body">
              <p class="text-uppercase text-sm">Address Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Street</label
                  >
                  <input
                    v-model="partner.street"
                    type="text"
                    class="form-control"
                    :readonly="!edit"
                  />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Street 2</label
                  >
                  <input
                    v-model="partner.street2"
                    type="text"
                    class="form-control"
                    :readonly="!edit"
                  />
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >City</label
                  >
                  <input 
                    v-model="partner.city"
                    type="text" 
                    class="form-control"
                    :readonly="!edit"/>
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >Country</label
                  >
                  <select v-model="partner.country_id" class="form-select" :disabled="!edit" @change="getProvince(partner.country_id)">
                    <option 
                      v-for="country in country_list"
                      :key="country.id"
                      :value="country.id"
                      >{{ country.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >Province</label
                  >
                  <select v-model="partner.state_id" class="form-select" :disabled="!edit">
                    <option 
                      v-for="prov in province_list"
                      :key="prov.id"
                      :value="prov.id" 
                      >
                      {{ prov.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >Postal code</label
                  >
                  <input v-model="partner.zip" type="text" class="form-control" :readonly="!edit"/>
                </div>
              </div>
              <hr class="horizontal dark" />
              <div class="d-flex justify-content-between">
                <p class="text-uppercase text-sm">Other Address</p>
                <button class="btn btn-xs btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#modalAddAddress" v-if="edit">
                  <i class="fa fa-plus" aria-hidden="true"></i> Add new
                </button>
              </div>
              <div class="row">
                <div class="col-md-4 mb-2" v-for="address,i in partner.other_address" :key="i">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-2">
                          <i class="fa fa-truck text-primary" aria-hidden="true" v-if="address.type == 'delivery'"></i>
                          <i class="fa fa-money text-primary" aria-hidden="true" v-if="address.type == 'invoice'"></i>
                        </div>
                        <div class="col">
                          <p class="font-weight-bold mb-0">{{ address.name }}</p>
                          <p class="text-secondary text-sm mb-0">{{ address.street }} {{address.street2}}</p>
                          <p class="text-secondary text-sm mb-0">{{ address.city }} {{ address.state }} {{ address.zip }}</p>
                          <p class="text-secondary text-sm mb-0">{{ address.country }}</p>
                          <p class="text-secondary text-sm mb-0" v-if="address.phone">Phone: {{ address.phone }}</p>
                          <p class="text-secondary text-sm mb-0" v-if="address.email">Email: {{ address.email }}</p>
                        </div>
                      </div>
                      <div class="d-grid gap-4 d-flex mt-3 mb-0 p-0 float-end" v-if="edit">
                        <button class="btn btn-xs btn-link m-0 p-0" @click="editAddress(i)" data-bs-toggle="modal" data-bs-target="#modalAddAddress">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
                        </button>
                        <button class="btn btn-xs btn-link text-danger m-0 p-0" @click="deleteAddress(i)">
                          <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="tab[2].visible && tab[2].active">
            <div class="card-body">
              <p class="text-uppercase text-sm">Document</p>
              <label for="siup">SIUP</label>
              <div class="col-md-4"  v-if="edit && !partner.siup_filename">
                <input type="file" class="form-control" accept="image/*,.pdf" @change="getSiupBinary">
              </div>
              <div class="d-grid gap-4 d-flex" v-else>
                <button 
                  type="button" 
                  class="text-sm btn-link btn p-0" 
                  @click="downloadAttachment(partnerId,'res.partner','siup_file',partner.siup_filename)">
                  {{ partner.siup_filename }}
                </button>
                <button v-if="edit" class="btn btn-link text-danger btn-xs p-0" @click="partner.siup_filename = null, partner.siup_file = null">
                  <i class="fa text-sm fa-trash" aria-hidden="true"></i> Delete
                </button>
              </div>
              
              <label for="siup">NPWP</label>
              <div class="col-md-4"  v-if="edit && !partner.npwp_filename">
                <input type="file" class="form-control" accept="image/*,.pdf" @change="getNpwpBinary">
              </div>
              <div class="d-grid gap-4 d-flex" v-else>
                <button 
                  type="button" 
                  class="text-sm btn-link btn p-0" 
                  @click="downloadAttachment(partnerId,'res.partner','npwp_file',partner.npwp_filename)">
                  {{ partner.npwp_filename }}
                </button>
                <button v-if="edit" class="btn btn-link text-danger btn-xs p-0" @click="partner.npwp_filename = null, partner.npwp_file = null">
                  <i class="fa text-sm fa-trash" aria-hidden="true"></i> Delete
                </button>
              </div>
              
              <label for="siup">Akta</label>
              <div class="col-md-4"  v-if="edit && !partner.akta_filename">
                <input type="file" class="form-control" accept="image/*,.pdf" @change="getAktaBinary">
              </div>
              <div class="d-grid gap-4 d-flex" v-else>
                <button 
                  type="button" 
                  class="text-sm btn-link btn p-0" 
                  @click="downloadAttachment(partnerId,'res.partner','akta_file',partner.akta_filename)">
                  {{ partner.akta_filename }}
                </button>
                <button v-if="edit" class="btn btn-link text-danger btn-xs p-0" @click="partner.akta_filename = null, partner.akta_file = null">
                  <i class="fa text-sm fa-trash" aria-hidden="true"></i> Delete
                </button>
              </div>
              <hr class="horizontal dark" />
              <div class="d-flex justify-content-between">
                <p class="text-uppercase text-sm">Awarding</p>
                <button class="btn btn-xs btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#modalAddAwarding" v-if="edit">
                  <i class="fa fa-plus" aria-hidden="true"></i> Add new
                </button>
              </div>
              <div class="table-response">
                <table class="table">
                  <thead class="text-xs bg-light">
                    <th class="ps-2">#</th>
                    <th class="ps-2">Name</th>
                    <th class="ps-2">File</th>
                    <th class="ps-2"></th>
                  </thead>
                  <tbody class="text-xs">
                    <tr v-for="award,i in partner.awarding_ids" :key="award.id">
                      <td>{{ i+1 }}</td>
                      <td>{{ award.name }}</td>
                      <td>
                        <button 
                          type="button" 
                          class="btn-link btn-xs btn p-0" 
                          @click="downloadAttachment(award.id,'res.partner.awarding','file',award.filename)">
                          {{ award.filename }}
                        </button>
                      </td>
                      <td>
                        <button v-if="edit" class="btn btn-link text-danger btn-xs p-0" @click="deleteAwarding(i)">
                          <i class="fa text-sm fa-trash" aria-hidden="true"></i> Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr class="horizontal dark" />
              <div class="d-flex justify-content-between">
                <p class="text-uppercase text-sm">Certification</p>
                <button class="btn btn-xs btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#modalAddCertificate" v-if="edit">
                  <i class="fa fa-plus" aria-hidden="true"></i> Add new
                </button>
              </div>
              <div class="table-response">
                <table class="table">
                  <thead class="text-xs bg-light">
                    <th class="ps-2">#</th>
                    <th class="ps-2">Name</th>
                    <th class="ps-2">File</th>
                    <th class="ps-2"></th>
                  </thead>
                  <tbody class="text-xs">
                    <tr v-for="cert,i in partner.certification_ids" :key="cert.id">
                      <td>{{ i+1 }}</td>
                      <td>{{ cert.name }}</td>
                      <td>
                        <button 
                          type="button" 
                          class="btn-link btn-xs btn p-0" 
                          @click="downloadAttachment(cert.id,'res.partner.certification','file',cert.filename)">
                          {{ cert.filename }}
                        </button>
                      </td>
                      <td>
                        <button v-if="edit" class="btn btn-link text-danger btn-xs p-0" @click="deleteCertificate(i)">
                          <i class="fa text-sm fa-trash" aria-hidden="true"></i> Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr class="horizontal dark" />
            </div>
          </div>

          <div class="card" v-if="tab[3].visible && tab[3].active">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <p class="text-uppercase text-sm">Corporate PIC</p>
                <button class="btn btn-xs btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#modalAddPIC" v-if="edit">
                  <i class="fa fa-plus" aria-hidden="true"></i> Add new
                </button>
              </div>
              <div class="row">
                <div class="col-md-4" v-for="p,i in partner.pic" :key="i">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-3">
                          <img
                            src="../assets/img/person.jpeg"
                            alt="pic_image"
                            class="shadow-sm w-100 border-radius-lg"
                          />
                        </div>
                        <div class="col-9">
                          <p class="font-weight-bold mb-0">{{ p.name }}</p>
                          <p class="text-secondary text-sm mb-0">{{ p.function }}</p>
                          <p class="text-secondary text-sm mb-0">{{ p.email }}</p>
                          <p class="text-secondary text-sm mb-0" v-if="p.phone">Phone: {{ p.phone }}</p>
                        </div>
                      </div>
                      <div class="d-grid gap-4 d-flex mt-3 mb-0 p-0 float-end" v-if="edit">
                        <button class="btn btn-xs btn-link m-0 p-0" @click="editPIC(i)" data-bs-toggle="modal" data-bs-target="#modalAddPIC">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
                        </button>
                        <button class="btn btn-xs btn-link text-danger m-0 p-0" @click="deletePIC(i)">
                          <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- modal -->
    <div class="modal fade" id="modalAddCertificate" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalAddCertificateLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalAddCertificateLabel">Certificate</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <label for="name">Name</label>
              <input v-model="modal.name" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">File</label>
              <input ref="file_certificate" type="file" class="form-control" accept="image/*,.pdf" @change='getAttachmentBinary'>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addCertificate">
              {{ indexCertificateEdited !== null ? 'Save' : 'Add' }}
            </button>
            <button ref="discardAddCertificate" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalAddAwarding" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalAddAwardingLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalAddAwardingLabel">Awarding</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <label for="name">Name</label>
              <input v-model="modal.name" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">File</label>
              <input ref="file_awarding" type="file" class="form-control" accept="image/*,.pdf" @change='getAttachmentBinary'>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addAwarding">
              {{ indexAwardingEdited !== null ? 'Save' : 'Add' }}
            </button>
            <button ref="discardAddAwarding" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalAddPIC" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalAddPICLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalAddPICLabel">PIC Corporate</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <label for="name">Name</label>
              <input v-model="modal.name" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Job Position</label>
              <input v-model="modal.function" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Email</label>
              <input v-model="modal.email" type="email" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Phone</label>
              <input v-model="modal.phone" type="text" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addPIC">
              {{ indexPICEdited !== null ? 'Save' : 'Add' }}
            </button>
            <button ref="discardAddPIC" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalAddAddress" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalAddAddressLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalAddAddressLabel">Other Address</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <div class="form-check form-check-inline">
                <input v-model="modal.type" class="form-check-input" type="radio" id="inlineRadio1" value="delivery">
                <label class="form-check-label" for="inlineRadio1">Delivery Address</label>
              </div>
              <div class="form-check form-check-inline">
                <input v-model="modal.type" class="form-check-input" type="radio" id="inlineRadio2" value="invoice">
                <label class="form-check-label" for="inlineRadio2">Invoice Address</label>
              </div>
            </div>
            <div class="col-md">
              <label for="name">Name</label>
              <input v-model="modal.name" type="text" class="form-control">
            </div>
            <label for="name">Address</label>
            <div class="row">
              <div class="col-md-12 mb-2">
                <input v-model="modal.street" type="text" class="form-control" placeholder="Street">
              </div>
              <div class="col-md-12 mb-2">
                <input v-model="modal.street2" type="text" class="form-control" placeholder="Street 2">
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label for="name">Country</label>
                <select v-model="modal.country_id" class="form-select" @change="getProvince(modal.country_id)">
                    <option 
                      v-for="country in country_list"
                      :key="country.id"
                      :value="country.id"
                      >{{ country.name }}
                    </option>
                  </select>
              </div>
              <div class="col-sm-4">
                <label for="name">Province</label>
                <select v-model="modal.state_id" class="form-select">
                    <option 
                      v-for="prov in province_list"
                      :key="prov.id"
                      :value="prov.id" 
                      >
                      {{ prov.name }}
                    </option>
                  </select>
              </div>
              <div class="col-sm-4">
                <label for="name">City</label>
                <input v-model="modal.city" type="text" class="form-control">
              </div>
              <div class="col-sm-4">
                <label for="name">Zip</label>
                <input v-model="modal.zip" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md">
              <label for="name">Phone</label>
              <input v-model="modal.phone" type="text" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addAddress">
              {{ indexAddressEdited !== null ? 'Save' : 'Add' }}
            </button>
            <button ref="discardAddAddress" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonButton from "@/components/ArgonButton.vue";
const endpoint = require("../router/endpoint");

const body = document.getElementsByTagName("body")[0];

export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      tab: [
        {
          'name': 'Info',
          'icon': 'fa-cubes',
          'visible': true,
          'active': true
        },
        {
          'name': 'Address',
          'icon': 'fa-building',
          'visible': false,
          'active': true
        },
        {
          'name': 'Document',
          'icon': 'fa-folder-open',
          'visible': false,
          'active': true
        },
        {
          'name': 'PIC',
          'icon': 'fa-users',
          'visible': false,
          'active': true
        },
      ],
      partner: {},
      partnerName: localStorage.getItem('name'),
      loading: false,
      edit: false,
      indexPICEdited: null,
      indexAddressEdited: null,
      indexCertificateEdited: null,
      indexAwardingEdited: null,
      modal: {
        id: null,
        image: null,
        name: null,
        phone: null,
        email: null,
        function: null, // job position
        type: null,
        street: null,
        street2: null,
        city: null,
        country_id: null,
        country: null,
        state_id: null,
        state: null,
        zip: null,
        file: null,
        filename: null,
        vendor_notification: null
      },
      country_list: [],
      province_list: []
    };
  },
  components: { ArgonButton },
  methods: {
    getAttachmentBinary (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.modal.file = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.modal.filename = event.target.files[0].name
    },
    getSiupBinary (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.partner.siup_file = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.partner.siup_filename = event.target.files[0].name
    },
    getAktaBinary (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.partner.akta_file = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.partner.akta_filename = event.target.files[0].name
    },
    getNpwpBinary (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.partner.npwp_file = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.partner.npwp_filename = event.target.files[0].name
    },
    clearModalVals() {
      this.modal.name = null
      this.modal.phone = null
      this.modal.email = null
      this.modal.function = null
      this.modal.type = null
      this.modal.street = null
      this.modal.street2 = null
      this.modal.city = null
      this.modal.country_id = null
      this.modal.country = null
      this.modal.state_id = null
      this.modal.state = null
      this.modal.zip = null
      this.modal.file = null
      this.modal.filename = null
      this.$refs.file_certificate.value = null;
      this.$refs.file_awarding.value = null;
    },
    addCertificate() {
      var vals = {
        'id': this.modal.id,
        'name': this.modal.name,
        'file': this.modal.file,
        'filename': this.modal.filename
      }
      if (this.modal.name && this.modal.file) {
        if (this.indexCertificateEdited !== null) {
          this.partner.certification_ids[this.indexcertificateEdited].name = this.modal.name
          this.partner.certification_ids[this.indexcertificateEdited].file = this.modal.file
          this.partner.certification_ids[this.indexcertificateEdited].filename = this.modal.filename
          this.indexcertificateEdited = null
        } else {
          this.partner.certification_ids.push(vals)
        }
        this.clearModalVals()
        this.$refs.discardAddCertificate.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Name and File are required!',
        });
      }
    },
    deleteCertificate(index) {
      this.partner.certification_ids.splice(index,1)
    },
    addAwarding() {
      var vals = {
        'id': this.modal.id,
        'name': this.modal.name,
        'file': this.modal.file,
        'filename': this.modal.filename
      }
      if (this.modal.name && this.modal.file) {
        if (this.indexAwardingEdited !== null) {
          this.partner.awarding_ids[this.indexAwardingEdited].name = this.modal.name
          this.partner.awarding_ids[this.indexAwardingEdited].file = this.modal.file
          this.partner.awarding_ids[this.indexAwardingEdited].filename = this.modal.filename
          this.indexAwardingEdited = null
        } else {
          this.partner.awarding_ids.push(vals)
        }
        this.clearModalVals()
        this.$refs.discardAddAwarding.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Name and File are required!',
        });
      }
    },
    deleteAwarding(index) {
      this.partner.awarding_ids.splice(index,1)
    },
    addPIC() {
      var vals = {
        'id': this.modal.id,
        'image': this.modal.image,
        'name': this.modal.name,
        'phone': this.modal.phone,
        'email': this.modal.email,
        'function': this.modal.function,
      }
      if (this.modal.name && this.modal.phone) {
        if (this.indexPICEdited !== null) {
          this.partner.pic[this.indexPICEdited].image = this.modal.image
          this.partner.pic[this.indexPICEdited].name = this.modal.name
          this.partner.pic[this.indexPICEdited].phone = this.modal.phone
          this.partner.pic[this.indexPICEdited].email = this.modal.email
          this.partner.pic[this.indexPICEdited].function = this.modal.function
          this.indexPICEdited = null
        } else {
          this.partner.pic.push(vals)
        }
        this.clearModalVals()
        this.$refs.discardAddPIC.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Name and Phone are required!',
        });
      }
    },
    editPIC(index) {
      this.indexPICEdited = index
      this.modal.id = this.partner.pic[index].id 
      this.modal.image = this.partner.pic[index].image 
      this.modal.name = this.partner.pic[index].name 
      this.modal.phone = this.partner.pic[index].phone 
      this.modal.email = this.partner.pic[index].email 
      this.modal.function = this.partner.pic[index].function 
    },
    deletePIC(index) {
      this.partner.pic.splice(index,1)
    },
    addAddress() {
      var vals = {
        'id': this.modal.id,
        'name': this.modal.name,
        'phone': this.modal.phone,
        'email': this.modal.email,
        'street': this.modal.street,
        'street2': this.modal.street2,
        'city': this.modal.city,
        'state_id': this.modal.state_id,
        'state': this.modal.state,
        'country_id': this.modal.country_id,
        'country': this.modal.country,
        'zip': this.modal.zip,
        'type': this.modal.type
      }
      if (this.modal.type && this.modal.name && this.modal.phone && this.modal.street && this.modal.street2 && this.modal.city && this.modal.state_id && this.modal.country_id && this.modal.zip) {
        if (this.indexAddressEdited !== null) {
          this.partner.other_address[this.indexAddressEdited].name = this.modal.name
          this.partner.other_address[this.indexAddressEdited].phone = this.modal.phone
          this.partner.other_address[this.indexAddressEdited].email = this.modal.email
          this.partner.other_address[this.indexAddressEdited].street = this.modal.street
          this.partner.other_address[this.indexAddressEdited].street2 = this.modal.street2
          this.partner.other_address[this.indexAddressEdited].city = this.modal.city
          this.partner.other_address[this.indexAddressEdited].state_id = this.modal.state_id
          this.partner.other_address[this.indexAddressEdited].state = this.modal.state
          this.partner.other_address[this.indexAddressEdited].country_id = this.modal.country_id
          this.partner.other_address[this.indexAddressEdited].country = this.modal.country
          this.partner.other_address[this.indexAddressEdited].zip = this.modal.zip
          this.partner.other_address[this.indexAddressEdited].type = this.modal.type
          this.indexAddressEdited = null
        } else {
          this.partner.other_address.push(vals)
        }
        this.clearModalVals()
        this.$refs.discardAddAddress.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Address Type, Name, Address, and Phone are required!',
        });
      }
    },
    editAddress(index) {
      this.indexAddressEdited = index
      this.modal.id = this.partner.other_address[index].id 
      this.modal.name = this.partner.other_address[index].name 
      this.modal.phone = this.partner.other_address[index].phone 
      this.modal.email = this.partner.other_address[index].email 
      this.modal.street = this.partner.other_address[index].street 
      this.modal.street2 = this.partner.other_address[index].street2 
      this.modal.city = this.partner.other_address[index].city 
      this.modal.country_id = this.partner.other_address[index].country_id 
      this.modal.country = this.partner.other_address[index].country 
      this.modal.state_id = this.partner.other_address[index].state_id 
      this.modal.state = this.partner.other_address[index].state 
      this.modal.zip = this.partner.other_address[index].zip 
      this.modal.type = this.partner.other_address[index].type 
    },
    deleteAddress(index) {
      this.partner.other_address.splice(index,1)
    },
    showTab(index) {
      var next_tab = this.tab[index].name
      this.tab.forEach(x => {
        if (next_tab === x.name) {
          x.visible = true
        } else {
          x.visible = false
        }
      });
    },
    getProvince(country_id) {
      this.province_list = []
      this.axios
        .post(
          endpoint.PROVINCE,
          {
            country_id: country_id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.province_list = response.data.data;
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    getCountry() {
      this.country_list = []
      this.axios
        .post(
          endpoint.COUNTRY,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.country_list = response.data.data;
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    getPartnerDetail() {
      this.loading = true
      this.axios
        .post(
          endpoint.PARTNER_PROFILE,
          {
            partner_id: localStorage.getItem('partner_user_id')
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.partner = response.data.data;
            this.getCountry();
            this.getProvince(this.partner.country_id);
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    save() {
      this.loading = true
      this.axios
        .post(
          endpoint.PARTNER_PROFILE_UPDATE,
          {
            partner_id: localStorage.getItem('partner_user_id'),
            edit: {
              phone: this.partner.phone,
              email: this.partner.email,
              vat: this.partner.vat,
              website: this.partner.website,
              street: this.partner.street,
              street2: this.partner.street2,
              city: this.partner.city,
              state_id: this.partner.state_id,
              country_id: this.partner.country_id,
              zip: this.partner.zip,
              siup_file: this.partner.siup_file,
              siup_filename: this.partner.siup_filename,
              npwp_file: this.partner.npwp_file,
              npwp_filename: this.partner.npwp_filename,
              akta_file: this.partner.akta_file,
              akta_filename: this.partner.akta_filename,
              pic: this.partner.pic,
              other_address: this.partner.other_address,
              certification_ids: this.partner.certification_ids,
              awarding_ids: this.partner.awarding_ids,
              vendor_notification: this.partner.vendor_notification
            }
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.$notify({
              type: 'success',
              title: 'Voila!',
              text: response.data.message,
            });
            this.getPartnerDetail()
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.edit = false
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
        });
    },
    discard() {
      this.getPartnerDetail()
      this.edit = false
    },
    downloadAttachment (id,model,field,filename) {
      // this.loading = true
      const values = {
          res_id: id,
          res_model: model,
          res_field: field,
      }
      this.axios
          .post(
          endpoint.GET_ATTACHMENT_BINARY,
          values,
          {
              headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
              }
          }
          )
          .then((response) => {
            if (response.data.response_code === "0000") {
                const linkSource = `data:${response.data.data.mimetype};base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = filename;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
            }
            this.loading = false
          })
          .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
              });
          });
    }
  },
  computed: {
    // a computed getter
    partnerId() {
      // `this` points to the component instance
      return localStorage.getItem('partner_user_id')
    }
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setNavPills();
    setTooltip();
    this.getPartnerDetail()
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
